import { render, staticRenderFns } from "./SpecialRequests.vue?vue&type=template&id=6d109e46&"
import script from "./SpecialRequests.vue?vue&type=script&lang=js&"
export * from "./SpecialRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports